import React from "react";
import useHasPermission from "../../hooks/useHasPermission";
import { QNotFound } from "@qualio/ui-components";
import { UserPermissions } from "../../domain/permissions";

type Props = {
  permissions: readonly UserPermissions[];
  showNotFound?: boolean;
  children?: React.ReactNode;
};
export const PermissionCheck: React.FC<Props> = ({
  permissions,
  showNotFound,
  children,
}) => {
  const perms = useHasPermission(permissions);

  if (!Object.entries(perms).every(([, value]) => !!value)) {
    return showNotFound ? <QNotFound data-cy="not-found" /> : null;
  }

  return <>{children}</>;
};
